import { ConfigProcessor, parseBoolean, parseJSON } from '../utils/config/ConfigProcessor';
 
const env = new ConfigProcessor(
  {
    REACT_APP_DEBUG: { default: false, parser: parseBoolean },
    REACT_APP_PAGE_TITLE: { default: 'StreamingIndexing' },
    REACT_APP_TITLE: { default: '' },
    REACT_APP_SLUGLINE: { default: '' },
    REACT_APP_COLORS: { default: { primary: "#256beb" }, parser: parseJSON },
    REACT_APP_SERVER_URL: { default: window.location.origin },
    REACT_APP_LIVE_STREAMING_URL: { default: '' },
    REACT_APP_HIDE_PUBLIC_TRANSCRIPTION_TABS: { default: false, parser: parseBoolean },
  },
  process.env
);

const config = {
  debug: env.get('REACT_APP_DEBUG'),
  pageTitle: env.get('REACT_APP_PAGE_TITLE'),
  title: env.get('REACT_APP_TITLE'),
  slugline: env.get('REACT_APP_SLUGLINE'),
  colors: env.get('REACT_APP_COLORS'),
  serverUrl: env.get('REACT_APP_SERVER_URL'),
  liveStreamingUrl: env.get('REACT_APP_LIVE_STREAMING_URL'),
  hidePublicTranscriptionTabs: env.get('REACT_APP_HIDE_PUBLIC_TRANSCRIPTION_TABS'),
};

export default config;
